module.exports = __webpack_public_path__ + "img/rock-huge-10.6420a368.png";